document.documentElement.classList.add('pn-js');

/* ==========================================================
   FEATURED COLLEGES MOBILE SLIDER
========================================================== */

document.addEventListener('DOMContentLoaded', () => {

  const slider = document.querySelector('[data-pn-college-slider]');
  const dots = Array.from(
    document.querySelectorAll('.pn-colleges__dots span')
  );

  if (!slider || !dots.length) return;


  const updateCollegeDots = () => {

    if (window.innerWidth > 749) return;

    const cards = Array.from(
      slider.querySelectorAll('.pn-college-card')
    );

    if (!cards.length) return;


    const sliderLeft = slider.getBoundingClientRect().left;

    let closestIndex = 0;
    let closestDistance = Infinity;


    cards.forEach((card, index) => {

      const distance = Math.abs(
        card.getBoundingClientRect().left - sliderLeft
      );

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }

    });


    dots.forEach((dot, index) => {
      dot.classList.toggle(
        'is-active',
        index === closestIndex
      );
    });

  };


  let ticking = false;


  slider.addEventListener(
    'scroll',
    () => {

      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        updateCollegeDots();
        ticking = false;
      });

    },
    { passive: true }
  );


  updateCollegeDots();

});
